import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Button, Container, Form, Modal, Table } from 'react-bootstrap';
import Select from 'react-select';
import {
  ActionButtons,
  addStatusToast,
  InputNumber,
  InputText,
  Loader,
  SectionHeader,
  VerticalTabPane,
  VerticalTabs,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { LOADING_STATUS } from '../../common/constants';
import {
  AccountDetailsFromDb,
  AccountUpdateData,
  AddressResponse,
  AddressUpdateData,
  ContactUpdateData,
  CustomerSettingsResponse,
  CustomerSettingsUpdateData,
  DefaultGroupFilter,
  EmailResponse,
  EmailUpdateData,
  getAcountDetailsFromDbAsync,
  getAllCustomerGroupsAsync,
  getAllRolesAsync,
  getCustomerSettingsAsync,
  getDefaultCustomerGroupAsync,
  PhoneResponse,
  PhoneUpdateData,
  resetAccountDetailsAsync,
  selectAccountDetailsFromDb,
  selectAccountDetailsLoadingStatus,
  selectAllRoles,
  selectCustomerGroups,
  selectCustomerGroupsLoadingStatus,
  selectCustomerSettings,
  selectDefaultCustomerGroup,
  selectRolesLoadingStatus,
  selectUserRoles,
  updateAccountDataAsync,
  UpdateCustomerSettinsAsync,
  UpdateVatSettinsAsync,
  VatSettingsResponse,
} from '../Users/identityUsersSlice';
import {
  getCountriesAsync,
  selectCountryItems,
} from '../countries/countriesSlice';
import InputCheck from '../../common/components/Input/InputCheck';
import { WebShopCustomerItem } from '../bookings/bookingsSlice';

function AddNewCustomer() {
  const backLinkUrl = '/customers/search';
  const params = useParams();
  const dispatch = useAppDispatch();
  const allRoles = useAppSelector(selectAllRoles);
  const userRoles = useAppSelector(selectUserRoles);
  const rolesStatus = useAppSelector(selectRolesLoadingStatus);
  const countries = useAppSelector(selectCountryItems);
  const allGroups = useAppSelector(selectCustomerGroups);
  const defaultGroup = useAppSelector(selectDefaultCustomerGroup);
  const allGroupsLoadingStatus = useAppSelector(
    selectCustomerGroupsLoadingStatus,
  );
  const accountDetails = useAppSelector(selectAccountDetailsFromDb);
  const customerSettings = useAppSelector(selectCustomerSettings);
  const accountLoadingStatus = useAppSelector(
    selectAccountDetailsLoadingStatus,
  );
  const location = useLocation();
  const mystate = location.state as {
    payer: string;
    bookingId: string;
    bookingType: string;
    bookingLocale: string;
    webshopCustomer: WebShopCustomerItem;
  }; // Type assertion for TypeScript
  const { webshopCustomer } = mystate !== null ? mystate : {};

  const [isAddressModalVisible, setIsAddressModalVisible] =
    useState<boolean>(false);
  const [isPhoneModalVisible, setIsPhoneModalVisible] =
    useState<boolean>(false);
  const [isEMailModalVisible, setIsEMailModalVisible] =
    useState<boolean>(false);

  function getIsOfficer() {
    const filteredRoles =
      allRoles != null && allRoles.rolesList != null
        ? allRoles.rolesList.filter(
            ar =>
              userRoles.includes(ar.id) && ar.name.includes('Administrator'),
          )
        : null;
    return filteredRoles != null && filteredRoles.length > 0;
  }

  const Tabs: string[] = [
    'Perustiedot',
    'Yhteystiedot',
    'Roolit',
    'Asiakaskohtaiset asetukset',
  ];
  const webshopstate = location.state as {
    payer: string;
    bookingId: string;
    bookingType: string;
    webshopCustomer: WebShopCustomerItem;
  }; // Type assertion for TypeScript
  const [activeTab, setActiveTab] = useState<string>(Tabs[0]);
  const [editedCustomerSettings, setEditedCustomerSettings] =
    useState<CustomerSettingsResponse>({
      id: '',
      customerNumber: null,
      accountId: '',
      customerGroupId: '',
      additionalInfo: '',
      advanceInvoiceDueDateOffsetDays: null,
      billingLocale: '',
      bookingOfficeTenantId: '',
      complaints: '',
      discountVatP: null,
      domesticPriceMultiplier: null,
      finalInvoiceDueDateOffsetDays: null,
      invoiceByEmail: false,
      invoiceByInternet: false,
      invoiceByMail: false,
      isAdvanceInvoiceAllowed: false,
      isDeleted: false,
      isRegularCustomer: false,
      isDomestic: false,
      useCancelInsurance: true,
      isSkiCenterCustomer: false,
      marketingAuthorizationViaEmail: false,
      fullEmailMarketingAllowed: false,
      marketingAuthorizationViaSms: false,
      officeFee: false,
      travelAgencyCommission: null,
      travelAgencyVat: null,
    } as CustomerSettingsResponse);

  const [editedEmail, setEditedEmail] = useState<EmailResponse>({
    id: '',
    description: '',
    emailAddress: '',
    isPrimary: false,
    isBookingNoteEmail: false,
  } as EmailResponse);

  const [editedPhone, setEditedPhone] = useState<PhoneResponse>({
    id: '',
    typeId: '',
    phoneNumber: '',
    description: '',
    isPrimary: false,
    bookingNoteBySms: false,
  } as PhoneResponse);

  const [editedAddress, setEditedAddress] = useState<AddressResponse>({
    id: null,
    postStreetAddress: '',
    postCity: '',
    postCode: '',
    isPrimary: false,
    description: '',
    additionalAddressLine: '',
    countryId: '',
  } as AddressResponse);

  const [editedRoles, setEditedRoles] = useState<string[]>([]);

  function getIsCustomer() {
    const filteredRoles =
      allRoles != null && allRoles.rolesList != null
        ? allRoles.rolesList.filter(
            ar => editedRoles.includes(ar.id) && ar.name.includes('Customer'),
          )
        : null;
    const retVal = filteredRoles != null && filteredRoles.length > 0;
    return retVal;
  }
  function getVatUpdateData(accountId) {
    const vatUpdateData = {
      id: '',
      accountId,
      hetu: '',
      otherVatCode: '',
      paysVat: false,
      yCode: '',
    } as VatSettingsResponse;

    return vatUpdateData;
  }
  function addSelectedRole(roleId) {
    if (
      !editedRoles.some(s => s.toUpperCase().includes(roleId.toUpperCase()))
    ) {
      if (
        editedRoles.some(s =>
          s.toUpperCase().includes(roleId.toUpperCase()),
        ) === true
      ) {
        return;
      }
      const tempuserRoles = [...editedRoles, roleId.toUpperCase().toString()];
      setEditedRoles(tempuserRoles);
    } else {
      setEditedRoles(editedRoles);
    }
  }
  const GetCustomerRole = () => {
    const retVal =
      allRoles != null && allRoles.rolesList != null
        ? allRoles.rolesList.find(r => r.name === 'Customer')
        : null;
    if (retVal != null) {
      addSelectedRole(retVal.id);
    }
  };

  const [editedAccount, setEditedAccount] = useState<AccountDetailsFromDb>({
    id: '',
    addresses: [
      {
        id: '',
        postStreetAddress: '',
        postCity: '',
        postCode: '',
        isPrimary: false,
        description: '',
        additionalAddressLine: '',
        countryId: '',
      },
    ] as AddressResponse[],
    companyName: '',
    additionalInformation: '',
    description: '',
    emails: [
      {
        id: '',
        description: '',
        emailAddress: '',
        isPrimary: false,
        isBookingNoteEmail: false,
      } as EmailResponse,
    ],
    firstName: '',
    lastName: '',
    phones: [
      {
        id: '',
        typeId: '',
        phoneNumber: '',
        description: '',
        isPrimary: false,
        bookingNoteBySms: false,
      } as PhoneResponse,
    ],
    www: '',
    subjectId: '',
  } as AccountDetailsFromDb);
  function resetData() {
    dispatch(
      resetAccountDetailsAsync({
        id: 'new',
        addresses: [
          {
            id: '',
            postStreetAddress: '',
            postCity: '',
            postCode: '',
            isPrimary: false,
            description: '',
            additionalAddressLine: '',
            countryId: '',
          },
        ] as AddressResponse[],
        companyName: '',
        additionalInformation: '',
        description: '',
        emails: [
          {
            id: '',
            description: '',
            emailAddress: '',
            isPrimary: false,
            isBookingNoteEmail: false,
          } as EmailResponse,
        ],
        firstName: '',
        lastName: '',
        phones: [
          {
            id: '',
            typeId: '',
            phoneNumber: '',
            description: '',
            isPrimary: false,
          } as PhoneResponse,
        ],
        www: '',
        subjectId: '',
      } as AccountDetailsFromDb),
    );
    setEditedAccount({
      id: '',
      addresses: [
        {
          id: '',
          postStreetAddress: '',
          postCity: '',
          postCode: '',
          isPrimary: false,
          description: '',
          additionalAddressLine: '',
          countryId: '',
        },
      ] as AddressResponse[],
      companyName: '',
      additionalInformation: '',
      description: '',
      emails: [
        {
          id: '',
          description: '',
          emailAddress: '',
          isPrimary: false,
          isBookingNoteEmail: false,
        } as EmailResponse,
      ],
      firstName: '',
      lastName: '',
      phones: [
        {
          id: '',
          typeId: '',
          phoneNumber: '',
          description: '',
          isPrimary: false,
          bookingNoteBySms: false,
        } as PhoneResponse,
      ],
      www: '',
      subjectId: '',
    } as AccountDetailsFromDb);
    setEditedPhone({
      id: '',
      typeId: '',
      phoneNumber: '',
      description: '',
      isPrimary: false,
      bookingNoteBySms: false,
    } as PhoneResponse);
    setEditedAddress({
      id: null,
      postStreetAddress: '',
      postCity: '',
      postCode: '',
      isPrimary: false,
      description: '',
      additionalAddressLine: '',
      countryId: '',
    } as AddressResponse);
    setEditedEmail({
      id: '',
      description: '',
      emailAddress: '',
      isPrimary: false,
      isBookingNoteEmail: false,
    } as EmailResponse);
    setEditedRoles([]);
  }
  function clearCustomer() {
    setEditedAccount({
      id: '',
      addresses: [
        {
          id: '',
          postStreetAddress: '',
          postCity: '',
          postCode: '',
          isPrimary: true,
          description: '',
          additionalAddressLine: '',
          countryId: '',
        },
      ] as AddressResponse[],
      companyName: '',
      additionalInformation: '',
      description: '',
      emails: [
        {
          id: '',
          description: '',
          emailAddress: '',
          isPrimary: true,
          isBookingNoteEmail: true,
        } as EmailResponse,
      ],
      firstName: '',
      lastName: '',
      phones: [
        {
          id: '',
          typeId: '',
          phoneNumber: '',
          description: '',
          isPrimary: true,
          bookingNoteBySms: true,
        } as PhoneResponse,
      ],
      www: '',
      subjectId: '',
    } as AccountDetailsFromDb);
    setEditedPhone({
      id: '',
      typeId: '',
      phoneNumber: '',
      description: '',
      isPrimary: true,
      bookingNoteBySms: true,
    } as PhoneResponse);
    setEditedAddress({
      id: '',
      postStreetAddress: '',
      postCity: '',
      postCode: '',
      isPrimary: true,
      description: '',
      additionalAddressLine: '',
      countryId: '',
    } as AddressResponse);
    setEditedEmail({
      id: '',
      description: '',
      emailAddress: '',
      isPrimary: true,
      isBookingNoteEmail: true,
    } as EmailResponse);
    setEditedCustomerSettings({
      customerGroupId:
        defaultGroup !== null && defaultGroup !== undefined
          ? defaultGroup.id
          : '',
      accountId: '',
      officeFee: true,
      additionalInfo: '',
      complaints: '',
      advanceInvoiceDueDateOffsetDays: 14,
      customerNumber: null,
      billingLocale: (mystate && mystate.bookingLocale) ?? 'fi_FI',
      bookingOfficeTenantId: '',
      discountVatP: 13.5,
      domesticPriceMultiplier: 1,
      finalInvoiceDueDateOffsetDays: 42,
      invoiceByEmail: true,
      invoiceByInternet: false,
      isRegularCustomer: false,
      invoiceByMail: false,
      isDeleted: false,
      isDomestic:
        !mystate || !mystate.bookingLocale || mystate.bookingLocale === 'fi_FI',
      useCancelInsurance: true,
      isSkiCenterCustomer: false,
      marketingAuthorizationViaEmail: false,
      fullEmailMarketingAllowed: false,
      marketingAuthorizationViaSms: false,
      travelAgencyCommission: 0,
      travelAgencyVat: 25.5,
      isAdvanceInvoiceAllowed: true,
    } as CustomerSettingsResponse);
  }
  function fillWebshopCustomer(webshopCustomerData: WebShopCustomerItem) {
    // let group = [];
    // if (allGroups != null && allGroups.length > 0) {
    //   group = allGroups.filter(
    //     cg =>
    //       cg.translations.filter(t =>
    //         t.text.includes('8| 15= kotimainen suora'),
    //       ).length > 0,
    //   );
    // }
    setEditedAccount({
      id: '',
      addresses: [
        {
          id: '',
          postStreetAddress: webshopCustomerData.streetAddress,
          postCity: webshopCustomerData.postCity,
          postCode: webshopCustomerData.postalCode,
          isPrimary: true,
          description: '',
          additionalAddressLine: webshopCustomerData.additionalAddress,
          countryId: webshopCustomerData.countryId,
        },
      ] as AddressResponse[],
      firstName:
        webshopCustomerData.companyName &&
        webshopCustomerData.companyName.length > 1
          ? ''
          : webshopCustomerData.firstName,
      lastName:
        webshopCustomerData.companyName &&
        webshopCustomerData.companyName.length > 1
          ? webshopCustomerData.companyName
          : webshopCustomerData.lastName,
      companyName:
        webshopCustomerData.companyName &&
        webshopCustomerData.companyName.length > 1
          ? `${webshopCustomerData.lastName} ${webshopCustomerData.firstName}`
          : '',
      additionalInformation: '',
      description: '',
      emails: [
        {
          id: '',
          description: '',
          emailAddress: webshopCustomerData.email,
          isPrimary: true,
          isBookingNoteEmail: true,
        } as EmailResponse,
      ],
      phones: [
        {
          id: '',
          typeId: '',
          phoneNumber: webshopCustomerData.phoneNumber,
          description: '',
          isPrimary: true,
          bookingNoteBySms: true,
        } as PhoneResponse,
      ],
      www: '',
      subjectId: '',
    } as AccountDetailsFromDb);
    setEditedPhone({
      id: '',
      typeId: '',
      phoneNumber: webshopCustomerData.phoneNumber,
      description: '',
      isPrimary: true,
      bookingNoteBySms: true,
    } as PhoneResponse);
    setEditedAddress({
      id: '',
      postStreetAddress: webshopCustomerData.streetAddress,
      postCity: webshopCustomerData.postCity,
      postCode: webshopCustomerData.postalCode,
      isPrimary: true,
      description: '',
      additionalAddressLine: webshopCustomerData.additionalAddress,
      countryId: webshopCustomerData.countryId,
    } as AddressResponse);
    setEditedEmail({
      id: '',
      description: '',
      emailAddress: webshopCustomerData.email,
      isPrimary: true,
      isBookingNoteEmail: true,
    } as EmailResponse);
    setEditedCustomerSettings({
      customerGroupId:
        defaultGroup !== null && defaultGroup !== undefined
          ? defaultGroup.id
          : '',
      accountId: '',
      officeFee: true,
      additionalInfo: '',
      complaints: '',
      advanceInvoiceDueDateOffsetDays: 14,
      customerNumber: null,
      billingLocale: (mystate && mystate.bookingLocale) ?? 'fi_FI',
      bookingOfficeTenantId: '',
      discountVatP: 13.5,
      domesticPriceMultiplier: 0,
      finalInvoiceDueDateOffsetDays: 42,
      invoiceByEmail: true,
      invoiceByInternet: false,
      isRegularCustomer: false,
      invoiceByMail: false,
      isDeleted: false,
      useCancelInsurance: true,
      isDomestic:
        !mystate || !mystate.bookingLocale || mystate.bookingLocale === 'fi_FI',
      isSkiCenterCustomer: false,
      marketingAuthorizationViaEmail: false,
      fullEmailMarketingAllowed: false,
      marketingAuthorizationViaSms: false,
      travelAgencyCommission: 0,
      travelAgencyVat: 25.5,
      isAdvanceInvoiceAllowed: true,
    } as CustomerSettingsResponse);
  }
  const initFetch = useCallback(() => {
    if (
      editedAccount.firstName !== '' &&
      editedAccount.lastName !== '' &&
      (webshopCustomer === null || webshopCustomer === undefined)
    ) {
      resetData();
    }
    dispatch(
      getAllCustomerGroupsAsync({
        PageSize: 100,
        PageNumber: 1,
        Culture: 'fi_FI',
        SearchString: null,
      }),
    );
    if (mystate && mystate.bookingType !== null && mystate.bookingType !== '') {
      dispatch(
        getDefaultCustomerGroupAsync({
          Locale:
            mystate && mystate.bookingLocale ? mystate.bookingLocale : 'fi_FI',
          BookingType: Number.parseInt(mystate.bookingType, 10),
        } as DefaultGroupFilter),
      );
    } else {
      dispatch(
        getDefaultCustomerGroupAsync({
          Locale:
            mystate && mystate.bookingLocale ? mystate.bookingLocale : 'fi_FI',
          BookingType: 99,
        } as DefaultGroupFilter),
      );
    }
    dispatch(
      getCountriesAsync({
        PageNumber: 1,
        PageSize: 100000,
        searchString: '',
        culture: 'fi_FI',
      }),
    );
    dispatch(
      getAllRolesAsync({
        pageNumber: 1,
        pageSize: 10,
        culture: 'fi_FI',
        searchString: '',
      }),
    );
    if (webshopCustomer != null) {
      fillWebshopCustomer(webshopCustomer);
    } else {
      clearCustomer();
    }
  }, [dispatch, params.customerId, webshopCustomer]);

  useEffect(() => {
    initFetch();
  }, [initFetch, params.identityId]);

  useEffect(() => {
    if (accountDetails != null) {
      setEditedAccount(accountDetails);
    }
  }, [accountDetails]);
  useEffect(() => {
    if (allGroups != null) {
      if (webshopCustomer != null) {
        fillWebshopCustomer(webshopCustomer);
      } else {
        clearCustomer();
      }
    }
  }, [defaultGroup]);
  useEffect(() => {
    if (webshopCustomer != null) {
      fillWebshopCustomer(webshopCustomer);
    } else {
      clearCustomer();
    }
  }, [webshopCustomer]);

  useEffect(() => {
    if (userRoles != null) {
      setEditedRoles(userRoles);
    } else {
      setEditedRoles([]);
    }
  }, [userRoles]);
  useEffect(() => {
    if (customerSettings != null && editedCustomerSettings === null) {
      setEditedCustomerSettings(customerSettings);
    }
  }, [editedCustomerSettings, customerSettings]);

  useEffect(() => {}, [editedCustomerSettings]);

  useEffect(() => {
    if (allRoles != null) {
      GetCustomerRole();
    }
  }, [allRoles]);
  function getItem(locale, keyId, item) {
    if (item != null && item.translations != null) {
      const found = item.translations.filter(
        a => a.locale === locale && a.keyId === keyId,
      );
      if (found && found[0] && found[0].text) {
        return found[0].text;
      }
    }
    return '';
  }
  const groupsList = allGroups.map(pvat => {
    return {
      value: pvat.id,
      label: getItem('fi_FI', 'CustomerGroupName', pvat),
    };
  });

  useEffect(() => {
    if (editedRoles != null) {
      setEditedRoles(editedRoles);
    }
  }, [editedRoles]);
  function isSelected(itemId) {
    if (editedRoles != null && editedRoles.length > 0) {
      return editedRoles.some(s =>
        s.toUpperCase().includes(itemId.toUpperCase()),
      );
    }
    return false;
  }
  function getUpdateData() {
    let accountUpdateData: AccountUpdateData;
    accountUpdateData = {
      id: null,
      contactUpdateData: null,
      accountsRoles: null,
    } as AccountUpdateData;
    if (editedAccount != null) {
      accountUpdateData = { ...accountUpdateData, id: editedAccount.id };
      if (
        (!accountUpdateData.id.includes('new') &&
          accountUpdateData.id.length > 0) ||
        accountUpdateData.id === '' ||
        accountUpdateData.id === undefined
      ) {
        accountUpdateData = { ...accountUpdateData, id: 'new' };
      }
    }
    if (
      editedAccount !== null &&
      (editedAccount.firstName !== null ||
        editedAccount.lastName !== null ||
        editedAccount.www !== null ||
        editedAccount.companyName != null ||
        editedAccount.description !== null ||
        editedAccount.additionalInformation !== null)
    ) {
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: {
          firstName: editedAccount.firstName,
          companyName: editedAccount.companyName,
          additionalInformation: editedAccount.additionalInformation,
          addresses: null,
          description: editedAccount.description,
          emails: null,
          lastName: editedAccount.lastName,
          www: editedAccount.www,
          phones: null,
        },
      };
    } else {
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: {
          firstName: null,
          companyName: null,
          additionalInformation: null,
          addresses: null,
          description: null,
          emails: null,
          lastName: null,
          www: null,
          phones: null,
        } as ContactUpdateData,
      };
    }

    if (editedAccount != null && editedAccount.emails != null) {
      let contactdata = { ...accountUpdateData.contactUpdateData };
      contactdata = {
        ...contactdata,
        emails: editedAccount.emails.map(data => {
          return {
            id: data.id === 'new' ? null : data.id,
            isPrimary: data.isPrimary,
            isBookingNoteEmail: data.isBookingNoteEmail,
            description: data.description,
            emailAddress: data.emailAddress,
          } as EmailUpdateData;
        }),
      };
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: contactdata,
      };
    }

    if (editedAccount != null && editedAccount.phones != null) {
      let contactdata = { ...accountUpdateData.contactUpdateData };
      contactdata = {
        ...contactdata,
        phones: editedAccount.phones.map(data => {
          return {
            id: data.id === 'new' ? null : data.id,
            isPrimary: data.isPrimary,
            bookingNoteBySms: data.bookingNoteBySms,
            description: data.description,
            phoneNumber: data.phoneNumber,
            typeId: data.typeId,
          } as PhoneUpdateData;
        }),
      };
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: contactdata,
      };
    }

    if (editedAccount != null && editedAccount.addresses != null) {
      let contactdata = { ...accountUpdateData.contactUpdateData };
      contactdata = {
        ...contactdata,
        addresses: editedAccount.addresses.map(data => {
          return {
            id: data.id === 'new' ? null : data.id,
            isPrimary: data.isPrimary,
            description: data.description,
            additionalAddressLine: data.additionalAddressLine,
            countryId: data.countryId,
            postCode: data.postCode,
            postCity: data.postCity,
            postStreetAddress: data.postStreetAddress,
          } as AddressUpdateData;
        }),
      };
      accountUpdateData = {
        ...accountUpdateData,
        contactUpdateData: contactdata,
      };
    }
    if (userRoles != null) {
      const temproles = [...editedRoles];
      const updatedRoles = temproles.map(tr => tr);
      accountUpdateData = { ...accountUpdateData, accountsRoles: updatedRoles };
    }
    return accountUpdateData;
  }

  function getCustomerSettingsUpdateData() {
    return {
      id: editedCustomerSettings.id,
      accountId: editedCustomerSettings.accountId,
      additionalInfo: editedCustomerSettings.additionalInfo,
      advanceInvoiceDueDateOffsetDays:
        editedCustomerSettings.advanceInvoiceDueDateOffsetDays,
      billingLocale: editedCustomerSettings.billingLocale,
      customerNumber: editedCustomerSettings.customerNumber ?? 0,
      complaints: editedCustomerSettings.complaints,
      bookingOfficeTenantId: '7bf9e2e4-8567-4ef4-84ee-e38b23b72499',
      customerGroupId: editedCustomerSettings.customerGroupId,
      discountVatP: editedCustomerSettings.discountVatP,
      domesticPriceMultiplier: editedCustomerSettings.domesticPriceMultiplier,
      finalInvoiceDueDateOffsetDays:
        editedCustomerSettings.finalInvoiceDueDateOffsetDays,
      invoiceByEmail: editedCustomerSettings.invoiceByEmail,
      invoiceByInternet: editedCustomerSettings.invoiceByInternet,
      invoiceByMail: editedCustomerSettings.invoiceByMail,
      isAdvanceInvoiceAllowed: editedCustomerSettings.isAdvanceInvoiceAllowed,
      isRegularCustomer: editedCustomerSettings.isRegularCustomer,
      isDomestic: editedCustomerSettings.isDomestic,
      useCancelInsurance: editedCustomerSettings.useCancelInsurance,
      isSkiCenterCustomer: editedCustomerSettings.isSkiCenterCustomer,
      marketingAuthorizationViaEmail:
        editedCustomerSettings.marketingAuthorizationViaEmail,
      fullEmailMarketingAllowed:
        editedCustomerSettings.fullEmailMarketingAllowed,
      marketingAuthorizationViaSms:
        editedCustomerSettings.marketingAuthorizationViaSms,
      officeFee: editedCustomerSettings.officeFee,
      travelAgencyCommission: editedCustomerSettings.travelAgencyCommission,
      travelAgencyVat: editedCustomerSettings.travelAgencyVat,
    } as CustomerSettingsUpdateData;
  }
  const history = useNavigate();
  const updateCustomerSettings = event => {
    const updateData = getCustomerSettingsUpdateData();
    if (
      updateData.customerGroupId == null ||
      updateData.customerGroupId === '' ||
      updateData.customerGroupId === undefined
    ) {
      dispatch(
        addStatusToast({
          Message: `Asiakasryhmä puuttuu`,
          IsFailed: true,
          Title: 'Tallennus epäonnistui',
        }),
      );
      return;
    }
    if (
      updateData.accountId === null ||
      updateData.accountId === undefined ||
      updateData.accountId === ''
    ) {
      const updateDataOther = getUpdateData();
      dispatch(updateAccountDataAsync(updateDataOther)).then(res => {
        if (
          res.meta.requestStatus !== 'fulfilled' ||
          res.payload?.result == null
        ) {
          dispatch(
            addStatusToast({
              IsFailed: true,
              Message: `Asiakkaan tallennus epäonnistui.`,
            }),
          );
          return;
        }
        const updateAccountData = { ...editedAccount, id: res.payload.result };
        setEditedAccount(updateAccountData);
        updateData.accountId = res.payload.result;
        updateData.id = 'new';
        dispatch(UpdateCustomerSettinsAsync(updateData)).then(rescus => {
          if (rescus.meta.requestStatus !== 'fulfilled') {
            dispatch(
              addStatusToast({
                IsFailed: true,
                Message: `Asiakaskohtaisten asetusten tallennus epäonnistui.`,
              }),
            );
            return;
          }
          dispatch(
            addStatusToast({
              Message: `Asiakaskohtaiset asetukset on tallennettu.`,
            }),
          );
          dispatch(getCustomerSettingsAsync(updateData.accountId)).then(
            rescustsettings => {
              if (
                rescustsettings.meta.requestStatus === 'fulfilled' &&
                rescustsettings.payload != null
              ) {
                setEditedCustomerSettings(rescustsettings.payload);
                dispatch(
                  getAcountDetailsFromDbAsync(
                    rescustsettings.payload.accountId,
                  ),
                ).then(rescust => {
                  if (
                    rescust.meta.requestStatus === 'fulfilled' &&
                    rescust.payload != null
                  ) {
                    setEditedAccount(rescust.payload);
                    if (webshopCustomer != null) {
                      const saveCustomer = {
                        ...webshopCustomer,
                        firstName: editedAccount.firstName,
                        lastName: editedAccount.lastName,
                        companyName: editedAccount.companyName,
                      };
                      history(`/customers/details/${res.payload.result}`, {
                        state: {
                          saveCustomer,
                          bookingId: mystate.bookingId,
                          bookingType: mystate.bookingType,
                        },
                      });
                    } else if (res.payload.result != null) {
                      history(`/customers/details/${res.payload.result}`);
                    }
                  } else {
                    dispatch(
                      addStatusToast({
                        IsFailed: true,
                        Message: `Asiakkaan tilitietojen haku epäonnistui.`,
                      }),
                    );
                  }
                });
              } else {
                dispatch(
                  addStatusToast({
                    IsFailed: true,
                    Message: `Asiakasasetusten haku epäonnistui.`,
                  }),
                );
              }
            },
          );
        });
      });
    } else {
      updateData.id = 'new';
      dispatch(UpdateCustomerSettinsAsync(updateData));
      dispatch(
        addStatusToast({
          Message: `Asiakaskohtaiset asetukset on tallennettu.`,
        }),
      );
    }
  };

  function addRemoveSelectedRole(event, roleId) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value === true) {
      if (
        editedRoles.some(s =>
          s.toUpperCase().includes(roleId.toUpperCase()),
        ) === true
      ) {
        return;
      }

      const tempuserRoles = [...editedRoles, roleId.toUpperCase().toString()];
      setEditedRoles(tempuserRoles);
    } else if (
      editedRoles.some(s => s.toUpperCase().includes(roleId.toUpperCase()))
    ) {
      const itemIndex = editedRoles.findIndex(o =>
        o.toUpperCase().includes(roleId.toUpperCase()),
      );
      if (itemIndex > -1) {
        const tempUserRoles = [...editedRoles];
        tempUserRoles.splice(itemIndex, 1);
        setEditedRoles(tempUserRoles);
      }
    }
  }

  const rolesSelectOptions = allRoles?.rolesList.map(item => (
    <Form.Group controlId={item.id} className="mb-24" key={item.id}>
      <Form.Check
        className="mb-24"
        label={item.description}
        name={item.name}
        checked={isSelected(item.id.toUpperCase())}
        onChange={event => addRemoveSelectedRole(event, item.id)}
      />
    </Form.Group>
  ));
  const handleSelectChangeAddress = selectedOption => {
    if (
      editedAccount.addresses != null &&
      selectedOption != null &&
      selectedOption.id != null
    ) {
      const data = editedAccount.addresses.filter(
        add => add.id === selectedOption.id,
      );
      if (data.length > 0) {
        setEditedAddress(data[0]);
      }
    }
  };

  const handleSelectChangePhone = selectedOption => {
    if (
      editedAccount.phones != null &&
      selectedOption != null &&
      selectedOption.id != null
    ) {
      const data = editedAccount.phones.filter(
        add => add.id === selectedOption.id,
      );
      if (data.length > 0) {
        setEditedPhone(data[0]);
      }
    }
  };
  const handleSelectChangeEmail = selectedOption => {
    if (
      editedAccount.emails != null &&
      selectedOption != null &&
      selectedOption.id != null
    ) {
      const data = editedAccount.emails.filter(
        add => add.id === selectedOption.id,
      );
      if (data.length > 0) {
        setEditedEmail(data[0]);
      }
    }
  };
  const handleEditAddressClick = selectedOption => {
    handleSelectChangeAddress(selectedOption);
    setIsAddressModalVisible(true);
  };

  const handleEditPhoneClick = selectedOption => {
    handleSelectChangePhone(selectedOption);
    setIsPhoneModalVisible(true);
  };

  const handleEditEmailClick = selectedOption => {
    handleSelectChangeEmail(selectedOption);
    setIsEMailModalVisible(true);
  };

  function removeAddress(removedItem) {
    if (editedAccount != null && editedAccount.addresses != null) {
      const tempaddresses = editedAccount.addresses.filter(
        item => item.id !== removedItem.id,
      );

      const storedAccount = {
        ...editedAccount,
        addresses: tempaddresses,
      };
      setEditedAccount(storedAccount);
    }
  }

  function removePhone(removedItem) {
    if (editedAccount != null && editedAccount.phones != null) {
      const tempPhones = editedAccount.phones.filter(
        item => item.id !== removedItem.id,
      );

      const storedAccount = {
        ...editedAccount,
        phones: tempPhones,
      };
      setEditedAccount(storedAccount);
    }
  }

  function removeEmail(removedItem) {
    if (editedAccount != null && editedAccount.emails != null) {
      const tempEmail = editedAccount.emails.filter(
        item => item.id !== removedItem.id,
      );

      const storedAccount = {
        ...editedAccount,
        emails: tempEmail,
      };
      setEditedAccount(storedAccount);
    }
  }

  const accountAddressSelectOptions =
    accountLoadingStatus === LOADING_STATUS.IDLE &&
    editedAccount != null &&
    editedAccount.addresses != null ? (
      editedAccount?.addresses.map(item => (
        <tr key={item.id}>
          <td style={{ width: '100%' }}>{item.postStreetAddress ?? ''}</td>
          <td style={{ width: '100%' }}>{item.postCode ?? ''}</td>
          <td style={{ width: '100%' }}>{item.postCity ?? ''}</td>
          <td style={{ width: 100 }}>
            <Button
              variant="outline-blue"
              size="sm"
              onClick={() => handleEditAddressClick(item)}
            >
              Muokkaa
            </Button>
          </td>
          {/* <td className="pe-0"> */}
          {/*  <Button */}
          {/*    size="sm" */}
          {/*    variant="danger" */}
          {/*    onClick={() => removeAddress(item)} */}
          {/*  > */}
          {/*    X */}
          {/*  </Button> */}
          {/* </td> */}
        </tr>
      ))
    ) : (
      <div />
    );

  const accountPhonesSelectOptions =
    accountLoadingStatus === LOADING_STATUS.IDLE &&
    editedAccount != null &&
    editedAccount.phones != null ? (
      editedAccount?.phones.map(item => (
        <tr key={item.id}>
          <td style={{ width: '100%' }}>{item.phoneNumber ?? ''}</td>
          <td style={{ width: '100%' }}>{item.typeId ?? ''}</td>
          <td style={{ width: 100 }}>
            <Button
              variant="outline-blue"
              size="sm"
              onClick={() => handleEditPhoneClick(item)}
            >
              Muokkaa
            </Button>
          </td>
          {/* <td className="pe-0"> */}
          {/*  <Button */}
          {/*    size="sm" */}
          {/*    variant="danger" */}
          {/*    onClick={() => removePhone(item)} */}
          {/*  > */}
          {/*    X */}
          {/*  </Button> */}
          {/* </td> */}
        </tr>
      ))
    ) : (
      <div />
    );
  const handleInputChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const tempdata = { ...editedAccount, [name]: value };
    setEditedAccount(tempdata);
  };

  const handleInputChangeCustomerSettings = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const tempdata = { ...editedCustomerSettings, [name]: value };
    if (name === 'marketingAuthorizationViaEmail' && value === false) {
      tempdata.fullEmailMarketingAllowed = false;
    }
    setEditedCustomerSettings(tempdata);
  };
  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone: string): boolean => {
    const phoneRegex =
      /^[+]?[0-9]{1,4}?[-.\s]?(\(?\d{1,3}?\))?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    return phoneRegex.test(phone);
  };

  const updateAccount = event => {
    const updateData = getUpdateData();
    // Sanity check some data
    const updateDataSettings = getCustomerSettingsUpdateData();
    if (
      updateDataSettings.customerGroupId == null ||
      updateDataSettings.customerGroupId === '' ||
      updateDataSettings.customerGroupId === undefined
    ) {
      dispatch(
        addStatusToast({
          Message: `Asiakasryhmä puuttuu`,
          IsFailed: true,
          Title: 'Tallennus epäonnistui',
        }),
      );
      return;
    }

    if (
      updateData.contactUpdateData.firstName === '' &&
      updateData.contactUpdateData.lastName === ''
    ) {
      dispatch(
        addStatusToast({
          Message: `Nimitieto puuttuu`,
          IsFailed: true,
          Title: 'Tallennus epäonnistui',
        }),
      );
      return;
    }

    // if (updateData.contactUpdateData.emails.length <= 0) {
    //   dispatch(
    //     addStatusToast({
    //       Message: `Sähköposti puuttuu !!`,
    //       IsFailed: true,
    //       Title: 'Tallennus epäonnistui',
    //     }),
    //   );
    //   return;
    // }

    if (updateData.contactUpdateData.phones.length <= 0) {
      dispatch(
        addStatusToast({
          Message: `Puhelinnumero puuttuu !!`,
          IsFailed: true,
          Title: 'Tallennus epäonnistui',
        }),
      );
      return;
    }

    // if (updateData.contactUpdateData.emails.length > 0) {
    //   let isPrimary = false;
    //   updateData.contactUpdateData.emails.map(email => {
    //     if (email.isPrimary) {
    //       isPrimary = true;
    //     }
    //     return email;
    //   });
    //   if (!isPrimary) {
    //     dispatch(
    //       addStatusToast({
    //         Message: `Pää sähköposti puuttuu !!`,
    //         IsFailed: true,
    //         Title: 'Tallennus epäonnistui',
    //       }),
    //     );
    //     return;
    //   }
    // }

    // if (updateData.contactUpdateData.emails.length > 0) {
    //   let isPrimary = false;
    //   updateData.contactUpdateData.emails.map(email => {
    //     if (email.isPrimary) {
    //       if (validateEmail(email.emailAddress)) {
    //         isPrimary = true;
    //       }
    //     }
    //     return email;
    //   });
    //   if (!isPrimary) {
    //     dispatch(
    //       addStatusToast({
    //         Message: `Pää sähköposti puuttuu !! tai väärässä muodossa`,
    //         IsFailed: true,
    //         Title: 'Tallennus epäonnistui',
    //       }),
    //     );
    //     return;
    //   }
    // }

    if (updateData.contactUpdateData.phones.length > 0) {
      let isPrimary = false;
      updateData.contactUpdateData.phones.map(email => {
        if (email.isPrimary) {
          isPrimary = true;
        }
        return email;
      });
      if (!isPrimary) {
        dispatch(
          addStatusToast({
            Message: `Pää puhelinnumero puuttuu !!`,
            IsFailed: true,
            Title: 'Tallennus epäonnistui',
          }),
        );
        return;
      }
    }

    if (updateData.contactUpdateData.phones.length > 0) {
      let isPrimary = false;
      updateData.contactUpdateData.phones.map(email => {
        if (email.isPrimary) {
          if (validatePhone(email.phoneNumber)) {
            isPrimary = true;
          }
        }
        return email;
      });
      if (!isPrimary) {
        dispatch(
          addStatusToast({
            Message: `Pää puhelinnumero puuttuu !! tai väärässä muodossa`,
            IsFailed: true,
            Title: 'Tallennus epäonnistui',
          }),
        );
        return;
      }
    }

    // if (updateData.contactUpdateData.emails.length > 0) {
    //   let isPrimary = false;
    //   updateData.contactUpdateData.emails.map(email => {
    //     if (email.emailAddress != null && email.emailAddress !== '') {
    //       isPrimary = true;
    //     }
    //     return email;
    //   });
    //   if (!isPrimary) {
    //     dispatch(
    //       addStatusToast({
    //         Message: `Pää sähköposti tyhjä !!`,
    //         IsFailed: true,
    //         Title: 'Tallennus epäonnistui',
    //       }),
    //     );
    //     return;
    //   }
    // }

    if (updateData.contactUpdateData.phones.length > 0) {
      let isPrimary = false;
      updateData.contactUpdateData.phones.map(email => {
        if (email.phoneNumber != null && email.phoneNumber !== '') {
          isPrimary = true;
        }
        return email;
      });
      if (!isPrimary) {
        dispatch(
          addStatusToast({
            Message: `Pää puhelinnumero tyhjä !!`,
            IsFailed: true,
            Title: 'Tallennus epäonnistui',
          }),
        );
        return;
      }
    }

    if (updateData.contactUpdateData.addresses.length <= 0) {
      dispatch(
        addStatusToast({
          Message: `Osoitetieto puuttuu !!`,
          IsFailed: true,
          Title: 'Tallennus epäonnistui',
        }),
      );
      return;
    }

    if (updateData.contactUpdateData.addresses.length > 0) {
      let isPrimary = false;
      updateData.contactUpdateData.addresses.map(email => {
        if (email.isPrimary) {
          isPrimary = true;
        }
        return email;
      });
      if (!isPrimary) {
        dispatch(
          addStatusToast({
            Message: `Pää osoitetieto puuttuu !!`,
            IsFailed: true,
            Title: 'Tallennus epäonnistui',
          }),
        );
        return;
      }
    }

    if (updateData.contactUpdateData.addresses.length > 0) {
      let isPrimary = false;
      updateData.contactUpdateData.addresses.map(email => {
        if (email.countryId != null && email.countryId !== '') {
          isPrimary = true;
        }
        return email;
      });
      if (!isPrimary) {
        dispatch(
          addStatusToast({
            Message: `Osoitetiedosta puuttuu maavalinta !!`,
            IsFailed: true,
            Title: 'Tallennus epäonnistui',
          }),
        );
        return;
      }
    }

    dispatch(updateAccountDataAsync(updateData)).then(res => {
      if (
        res.meta.requestStatus !== 'fulfilled' ||
        res.payload?.result == null
      ) {
        dispatch(
          addStatusToast({
            IsFailed: true,
            Message: `Asiakkaan tallennus epäonnistui.`,
          }),
        );
        return;
      }
      const updateSettingsData = getCustomerSettingsUpdateData();
      const dispatchData = {
        ...updateSettingsData,
        accountId: res.payload.result,
        id: 'new',
      };
      dispatch(UpdateCustomerSettinsAsync(dispatchData))
        .then(rescus => {
          if (rescus.meta.requestStatus === 'rejected') {
            return;
          }
          const updateVatData = getVatUpdateData(res.payload.result);
          dispatch(UpdateVatSettinsAsync(updateVatData));
          dispatch(
            addStatusToast({
              Message: `Alv asetukset on tallennettu.`,
            }),
          );
          if (webshopCustomer != null) {
            const saveCustomer = {
              ...webshopCustomer,
              firstName: editedAccount.firstName,
              lastName: editedAccount.lastName,
              companyName: editedAccount.companyName,
            };
            history(`/customers/details/${res.payload.result}`, {
              state: {
                saveCustomer,
                bookingId: mystate.bookingId,
                bookingType: mystate.bookingType,
              },
            });
          } else if (res.payload != null) {
            history(`/customers/details/${res.payload.result}`, {
              state: {
                bookingId: mystate.bookingId,
                bookingType: mystate.bookingType,
              },
            });
          }
        })
        .catch(err => {});
      // dispatch(getAcountDetailsFromDbAsync(res.payload.result)).then(resval => {
      //   setEditedAccount(resval.payload);
      //   dispatch(getCustomerSettingsAsync(res.payload.result)).then(rescust => {
      //     console.debug('new customer 2 get customersettings:', rescust);
      //     setEditedCustomerSettings(rescust.payload.result);
      //   });
      // });
    });
    dispatch(
      addStatusToast({
        Message: `Tiedot on tallennettu.`,
      }),
    );
  };
  const editAddresses = (
    addressesIn: AddressResponse[],
    valuedata: AddressResponse,
  ) => {
    if (valuedata.id !== 'new') {
      return addressesIn.map(item => {
        if (item.id === valuedata.id) {
          item = valuedata;
          if (valuedata.isPrimary) {
            return { ...item, isPrimary: true };
          }
        } else if (valuedata.isPrimary) {
          item.isPrimary = false;
        }
        return item;
      });
    }
    valuedata.id = crypto.randomUUID();
    setEditedAddress(valuedata);
    addressesIn = [...addressesIn, valuedata];
    return addressesIn;
  };

  const editEmails = (
    addressesIn: EmailResponse[],
    valuedata: EmailResponse,
  ) => {
    if (valuedata.id !== 'new') {
      return addressesIn.map(item => {
        if (item.id === valuedata.id) {
          item = valuedata;
          if (valuedata.isPrimary) {
            return { ...item, isPrimary: true };
          }
        } else if (valuedata.isPrimary) {
          item.isPrimary = false;
        }
        return item;
      });
    }
    valuedata.id = crypto.randomUUID();
    setEditedEmail(valuedata);
    addressesIn = [...addressesIn, valuedata];
    return addressesIn;
  };

  const editPhones = (
    addressesIn: PhoneResponse[],
    valuedata: PhoneResponse,
  ) => {
    if (valuedata.id !== 'new') {
      return addressesIn.map(item => {
        if (item.id === valuedata.id) {
          item = valuedata;
          if (valuedata.isPrimary) {
            return { ...item, isPrimary: true };
          }
        } else if (valuedata.isPrimary) {
          item.isPrimary = false;
        }
        return item;
      });
    }
    valuedata.id = crypto.randomUUID();
    setEditedPhone(valuedata);
    addressesIn = [...addressesIn, valuedata];
    return addressesIn;
  };

  const addAddress = () => {
    const newaddress = {
      isPrimary: false,
      postStreetAddress: '',
      additionalAddressLine: '',
      postCity: '',
      countryId: null,
      postCode: '',
      description: '',
      id: 'new',
    } as AddressResponse;
    setEditedAddress(newaddress);
    let { addresses } = editedAccount;
    addresses = editAddresses(addresses, newaddress);
    const storeAccount = { ...editedAccount, addresses };
    setEditedAccount(storeAccount);
    setIsAddressModalVisible(true);
  };

  const addEmail = () => {
    const newemail = {
      isPrimary: false,
      isBookingNoteEmail: false,
      emailAddress: '',
      description: '',
      id: 'new',
    } as EmailResponse;
    setEditedEmail(newemail);
    let { emails } = editedAccount;
    emails = editEmails(emails, newemail);
    const customerDetailsStore = { ...editedAccount, emails };
    setEditedAccount(customerDetailsStore);
    setIsEMailModalVisible(true);
  };

  const addPhoneNumber = () => {
    const newPhone = {
      isPrimary: false,
      bookingNoteBySms: false,
      typeId: null,
      phoneNumber: '',
      description: '',
      id: 'new',
    } as PhoneResponse;
    setEditedPhone(newPhone);
    let { phones } = editedAccount;
    phones = editPhones(phones, newPhone);
    const customerDetailsStore = { ...editedAccount, phones };
    setEditedAccount(customerDetailsStore);
    setIsPhoneModalVisible(true);
  };
  const handleInputChangeEmail = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setEditedEmail({
      ...editedEmail,
      [name]: value,
    });
    const editedEmailTemp = {
      ...editedEmail,
      [name]: value,
    };
    let { emails } = editedAccount;
    emails = editEmails(emails, editedEmailTemp);
    const accountDetailsStore = { ...editedAccount, emails };
    setEditedAccount(accountDetailsStore);
  };

  const handleInputChangePhone = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setEditedPhone({
      ...editedPhone,
      [name]: value,
    });
    const editedPhoneTemp = {
      ...editedPhone,
      [name]: value,
    };
    let { phones } = editedAccount;
    phones = editPhones(phones, editedPhoneTemp);
    const accountDetailsStore = { ...editedAccount, phones };
    setEditedAccount(accountDetailsStore);
  };

  const countryOptions = countries.map(country => {
    return { value: country.id, label: country.name };
  });
  const handleInputChangeAddress = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setEditedAddress({
      ...editedAddress,
      [name]: value,
    });
    const editedAddressTemp = {
      ...editedAddress,
      [name]: value,
    };
    let { addresses } = editedAccount;
    addresses = editAddresses(addresses, editedAddressTemp);
    const accountDetailsStore = { ...editedAccount, addresses };
    setEditedAccount(accountDetailsStore);
  };

  const handleSelectChange = (selectedOption, name) => {
    const newaddressData = { ...editedAddress };
    newaddressData[name] = selectedOption.value;
    setEditedAddress(newaddressData);
    const editedAddressTemp = { ...newaddressData };
    let { addresses } = editedAccount;
    addresses = editAddresses(addresses, editedAddressTemp);
    const accountDetailsStore = { ...editedAccount, addresses };
    setEditedAccount(accountDetailsStore);
  };
  const handleSelectChangeCustomerGroup = (selectedOption, name) => {
    const newaddressData = { ...editedCustomerSettings };
    newaddressData[name] = selectedOption.value;
    setEditedCustomerSettings(newaddressData);
  };

  const accountEmailsSelectOptions =
    accountLoadingStatus === LOADING_STATUS.IDLE &&
    editedAccount != null &&
    editedAccount.emails != null ? (
      editedAccount?.emails.map(item => (
        <tr key={item.id}>
          <td style={{ width: '100%' }}>{item.emailAddress ?? ''}</td>
          <td style={{ width: 100 }}>
            <Button
              variant="outline-blue"
              size="sm"
              onClick={() => handleEditEmailClick(item)}
            >
              Muokkaa
            </Button>
          </td>
          {/* <td className="pe-0"> */}
          {/*  <Button */}
          {/*    size="sm" */}
          {/*    variant="danger" */}
          {/*    onClick={() => removeEmail(item)} */}
          {/*  > */}
          {/*    X */}
          {/*  </Button> */}
          {/* </td> */}
        </tr>
      ))
    ) : (
      <div />
    );

  return (
    <>
      <Helmet>
        <title>Asiakasiedot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={backLinkUrl}
          Breadcrumbs={['Asiakkaat']}
          Title="Asiakkaan tiedot"
        />

        {accountLoadingStatus === LOADING_STATUS.LOADING && (
          <Loader IsLoading />
        )}

        {accountLoadingStatus === LOADING_STATUS.IDLE && (
          <VerticalTabs
            ActiveTab={activeTab}
            ChangeTab={setActiveTab}
            TabContainerId="customerTabs"
            Tabs={Tabs}
          >
            <VerticalTabPane IsActive={activeTab === Tabs[0]} Name={Tabs[0]}>
              {editedAccount != null && (
                <div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="firstName"
                      Name="firstName"
                      Value={editedAccount.firstName ?? ''}
                      IsRequired={false}
                      Label="Etunimi"
                    />
                  </div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="lastName"
                      Name="lastName"
                      Value={editedAccount.lastName ?? ''}
                      IsRequired={false}
                      Label="Sukunimi / Yritys"
                    />
                  </div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="www"
                      Name="www"
                      Value={editedAccount.www ?? ''}
                      IsRequired={false}
                      Label="Www"
                    />
                  </div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="companyName"
                      Name="companyName"
                      Value={editedAccount.companyName ?? ''}
                      IsRequired={false}
                      Label="Yhteyshenkilö"
                    />
                  </div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="description"
                      Name="description"
                      Value={editedAccount.description ?? ''}
                      IsRequired={false}
                      Label="Kuvaus"
                    />
                  </div>
                  <div className="mb-24">
                    <InputText
                      HandleChange={handleInputChange}
                      Id="additionalInformation"
                      Name="additionalInformation"
                      Value={editedAccount.additionalInformation ?? ''}
                      IsRequired={false}
                      Label="Lisätiedot"
                    />
                  </div>
                </div>
              )}

              <ActionButtons
                CancelButtonUrl={backLinkUrl}
                HandleSave={event => updateAccount(event)}
              />
            </VerticalTabPane>
            <VerticalTabPane IsActive={activeTab === Tabs[1]} Name={Tabs[1]}>
              {/* <div className="d-flex align-items-start mt-48"> */}
              <h2 className="h5 h-md-4 flex-grow-1 me-16 mb-24">Osoite</h2>
              {/*  <Button size="sm" onClick={addAddress}> */}
              {/*    <Icon Name="plus" CssClass="me-8" /> */}
              {/*    Lisää uusi */}
              {/*  </Button> */}
              {/* </div> */}
              <div className="table-responsive-lg mb-48">
                <Table>
                  <tbody>{accountAddressSelectOptions}</tbody>
                </Table>
              </div>
              {/* <div className="d-flex align-items-start mt-48"> */}
              <h2 className="h5 h-md-4 flex-grow-1 me-16 mb-24">
                Puhelinnumero
              </h2>
              {/*  <Button size="sm" onClick={addPhoneNumber}> */}
              {/*    <Icon Name="plus" CssClass="me-8" /> */}
              {/*    Lisää uusi */}
              {/*  </Button> */}
              {/* </div> */}
              <div className="table-responsive-lg mb-48">
                <Table>
                  <tbody>{accountPhonesSelectOptions}</tbody>
                </Table>
              </div>
              {/* <div className="d-flex align-items-start mt-48"> */}
              <h2 className="h5 h-md-4 flex-grow-1 me-16 mb-24">
                Sähköposti-osoite
              </h2>
              {/*  <Button size="sm" onClick={addEmail}> */}
              {/*    <Icon Name="plus" CssClass="me-8" /> */}
              {/*    Lisää uusi */}
              {/*  </Button> */}
              {/* </div> */}
              <div className="table-responsive-lg mb-48">
                <Table>
                  <tbody>{accountEmailsSelectOptions}</tbody>
                </Table>
              </div>
              <ActionButtons
                CancelButtonUrl={backLinkUrl}
                HandleSave={event => updateAccount(event)}
              />
            </VerticalTabPane>

            <VerticalTabPane IsActive={activeTab === Tabs[2]} Name={Tabs[2]}>
              {rolesStatus === LOADING_STATUS.IDLE && (
                <div>{rolesSelectOptions}</div>
              )}
              <ActionButtons
                CancelButtonUrl={backLinkUrl}
                HandleSave={event => updateAccount(event)}
              />
            </VerticalTabPane>
            {editedCustomerSettings != null &&
              rolesStatus === LOADING_STATUS.IDLE &&
              getIsCustomer() && (
                <VerticalTabPane
                  IsActive={activeTab === Tabs[3]}
                  Name={Tabs[3]}
                >
                  <div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="customerNumber"
                        Name="customerNumber"
                        Value={editedCustomerSettings.customerNumber ?? ''}
                        IsRequired={false}
                        Label="Asiakasnumero"
                        IsReadOnly
                      />
                    </div>
                    <div className="mb-24">
                      <InputText
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="additionalInfo"
                        Name="additionalInfo"
                        Value={editedCustomerSettings.additionalInfo ?? ''}
                        IsRequired={false}
                        Label="Lisätiedot"
                      />
                    </div>
                    <div className="mb-24">
                      <InputText
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="complaints"
                        Name="complaints"
                        Value={editedCustomerSettings.complaints ?? ''}
                        IsRequired={false}
                        Label="Huomautukset"
                      />
                    </div>
                    <div className="mb-24">
                      <Form.Label>Asiakasryhmä</Form.Label>
                      <Select
                        inputId="customerGroupId"
                        name="customerGroupId"
                        placeholder="Valitse asiakasryhmä"
                        isClearable
                        isSearchable
                        options={groupsList}
                        onChange={option =>
                          handleSelectChangeCustomerGroup(
                            option,
                            'customerGroupId',
                          )
                        }
                        value={groupsList.filter(
                          option =>
                            option.value.toUpperCase() ===
                            editedCustomerSettings.customerGroupId.toUpperCase(),
                        )}
                        classNames={{
                          control: state =>
                            'form-control form-control-react-select',
                        }}
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="advanceInvoiceDueDateOffsetDays"
                        Name="advanceInvoiceDueDateOffsetDays"
                        Value={
                          editedCustomerSettings.advanceInvoiceDueDateOffsetDays ??
                          ''
                        }
                        IsRequired={false}
                        Label="Ennakkolaskun eräpäiväsääntö"
                      />
                    </div>
                    <div className="mb-24">
                      <Select
                        inputId="billingLocale"
                        name="billingLocale"
                        placeholder="Valitse laskutuskieli"
                        isClearable
                        isSearchable
                        options={[
                          { value: 'fi_FI', label: 'Suomi' },
                          { value: 'en_EN', label: 'Englanti' },
                        ]}
                        onChange={option =>
                          handleInputChangeCustomerSettings({
                            target: {
                              name: 'billingLocale',
                              value: option ? option.value : '',
                            },
                          })
                        }
                        value={
                          editedCustomerSettings.billingLocale
                            ? {
                                value: editedCustomerSettings.billingLocale,
                                label:
                                  editedCustomerSettings.billingLocale ===
                                  'fi_FI'
                                    ? 'Suomi'
                                    : 'Englanti',
                              }
                            : null
                        }
                        classNames={{
                          control: state =>
                            'form-control form-control-react-select',
                        }}
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="discountVatP"
                        Name="discountVatP"
                        Value={editedCustomerSettings.discountVatP ?? ''}
                        IsRequired={false}
                        Label="Alennuksen Alv%"
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="finalInvoiceDueDateOffsetDays"
                        Name="finalInvoiceDueDateOffsetDays"
                        Value={
                          editedCustomerSettings.finalInvoiceDueDateOffsetDays ??
                          ''
                        }
                        IsRequired={false}
                        Label="Loppulaskun eräpäiväsäätö"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="invoiceByMail"
                        Name="invoiceByMail"
                        Checked={editedCustomerSettings.invoiceByMail ?? false}
                        IsRequired={false}
                        Label="Lasku Postitse"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="invoiceByEmail"
                        Name="invoiceByEmail"
                        Checked={editedCustomerSettings.invoiceByEmail ?? false}
                        IsRequired={false}
                        Label="Lasku sähköPostitse"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="invoiceByInternet"
                        Name="invoiceByInternet"
                        Checked={
                          editedCustomerSettings.invoiceByInternet ?? false
                        }
                        IsRequired={false}
                        Label="Lasku Internet"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="isAdvanceInvoiceAllowed"
                        Name="isAdvanceInvoiceAllowed"
                        Checked={
                          editedCustomerSettings.isAdvanceInvoiceAllowed ??
                          false
                        }
                        IsRequired={false}
                        Label="Ennakkolasku sallittu"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="isRegularCustomer"
                        Name="isRegularCustomer"
                        Checked={
                          editedCustomerSettings.isRegularCustomer ?? false
                        }
                        IsRequired={false}
                        Label="Kanta-asiakas"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="isDomestic"
                        Name="isDomestic"
                        Checked={editedCustomerSettings.isDomestic ?? false}
                        IsRequired={false}
                        Label="Kotimainen asiakas"
                      />
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="useCancelInsurance"
                        Name="useCancelInsurance"
                        Checked={
                          editedCustomerSettings.useCancelInsurance ?? false
                        }
                        IsRequired={false}
                        Label="Peruutusturva"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="isSkiCenterCustomer"
                        Name="isSkiCenterCustomer"
                        Checked={
                          editedCustomerSettings.isSkiCenterCustomer ?? false
                        }
                        IsRequired={false}
                        Label="Hiihtokeskus asiakas"
                      />
                    </div>
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="marketingAuthorizationViaEmail"
                        Name="marketingAuthorizationViaEmail"
                        Checked={
                          editedCustomerSettings.marketingAuthorizationViaEmail ??
                          false
                        }
                        IsRequired={false}
                        Label="Markkinointilupa email"
                      />
                      <InputCheck
                        IsReadOnly={
                          !editedCustomerSettings.marketingAuthorizationViaEmail
                        }
                        Checked={
                          (editedCustomerSettings.marketingAuthorizationViaEmail &&
                            editedCustomerSettings.fullEmailMarketingAllowed) ??
                          false
                        }
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="fullEmailMarketingAllowed"
                        Name="fullEmailMarketingAllowed"
                        IsRequired={false}
                        Label="Täysi email markkinointi (vain jos markkinointilupa annettu)"
                      />
                    </div>
                    <InputCheck
                      HandleChange={handleInputChangeCustomerSettings}
                      Id="marketingAuthorizationViaSms"
                      Name="marketingAuthorizationViaSms"
                      Checked={
                        editedCustomerSettings.marketingAuthorizationViaSms ??
                        false
                      }
                      IsRequired={false}
                      Label="Markkinointilupa sms"
                    />
                    <div className="mb-24">
                      <InputCheck
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="officeFee"
                        Name="officeFee"
                        Checked={editedCustomerSettings.officeFee ?? false}
                        IsRequired={false}
                        Label="Toimitusmaksu"
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="travelAgencyCommission"
                        Name="travelAgencyCommission"
                        Value={
                          editedCustomerSettings.travelAgencyCommission ?? ''
                        }
                        IsRequired={false}
                        Label="Matkatoimisto komissio"
                      />
                    </div>
                    <div className="mb-24">
                      <InputNumber
                        HandleChange={handleInputChangeCustomerSettings}
                        Id="travelAgencyVat"
                        Name="travelAgencyVat"
                        Value={editedCustomerSettings.travelAgencyVat ?? ''}
                        IsRequired={false}
                        Label="Matkatoimisto Alv%"
                      />
                    </div>
                  </div>
                  <ActionButtons
                    CancelButtonUrl={backLinkUrl}
                    HandleSave={event => updateCustomerSettings(event)}
                  />
                </VerticalTabPane>
              )}
          </VerticalTabs>
        )}
        <Modal show={isAddressModalVisible} backdrop="static">
          <Modal.Header>
            <Modal.Title>Muokkaa osoitetta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="postStreetAddress" className="mb-24">
              <Form.Label>Katuosoite</Form.Label>
              <Form.Control
                name="postStreetAddress"
                value={editedAddress.postStreetAddress ?? ''}
                onChange={handleInputChangeAddress}
              />
            </Form.Group>

            <Form.Group controlId="additionalAddressLine" className="mb-24">
              <Form.Label>Osoitteen lisärivi</Form.Label>
              <Form.Control
                name="additionalAddressLine"
                value={editedAddress.additionalAddressLine ?? ''}
                onChange={handleInputChangeAddress}
              />
            </Form.Group>

            <Form.Group controlId="postCode" className="mb-24">
              <Form.Label>Postinumero</Form.Label>
              <Form.Control
                name="postCode"
                value={editedAddress.postCode ?? ''}
                onChange={handleInputChangeAddress}
              />
            </Form.Group>

            <Form.Group controlId="postCity" className="mb-24">
              <Form.Label>Postitoimipaikka</Form.Label>
              <Form.Control
                name="postCity"
                value={editedAddress.postCity ?? ''}
                onChange={handleInputChangeAddress}
              />
            </Form.Group>
            <Form.Group className="mb-24">
              <Form.Label>Maa</Form.Label>
              <Select
                inputId="countryId"
                name="countryId"
                placeholder="Valitse maa"
                isClearable
                isSearchable
                options={countryOptions}
                onChange={option => handleSelectChange(option, 'countryId')}
                value={countryOptions.filter(
                  option =>
                    option !== undefined &&
                    editedAddress !== undefined &&
                    editedAddress.countryId !== undefined &&
                    option.value.toUpperCase() ===
                      editedAddress.countryId.toUpperCase(),
                )}
                classNames={{
                  control: state => 'form-control form-control-react-select',
                }}
              />
            </Form.Group>
            <Form.Check
              className="my-24"
              label="Oletusosoite ?"
              id="isPrimary"
              name="isPrimary"
              onChange={handleInputChangeAddress}
              inline
              checked={editedAddress.isPrimary}
            />
          </Modal.Body>
          <Modal.Footer>
            <span className="text-danger">Muista tallentaa muutokset !</span>
            <Button
              variant="link"
              onClick={() => setIsAddressModalVisible(false)}
            >
              Sulje
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={isPhoneModalVisible} backdrop="static">
          <Modal.Header>
            <Modal.Title>Muokkaa puhelinnumeroa</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="phoneNumber" className="mb-24">
              <Form.Label>Puhelinnumero</Form.Label>
              <Form.Control
                name="phoneNumber"
                value={editedPhone.phoneNumber ?? ''}
                onChange={handleInputChangePhone}
              />
            </Form.Group>

            <Form.Group controlId="description" className="mb-24">
              <Form.Label>Kuvaus</Form.Label>
              <Form.Control
                name="description"
                value={editedPhone.description ?? ''}
                onChange={handleInputChangePhone}
              />
            </Form.Group>
            <Form.Check
              className="my-24"
              label="Oletusnumero ?"
              id="isPrimary"
              name="isPrimary"
              onChange={handleInputChangePhone}
              inline
              checked={editedPhone.isPrimary}
            />
            <Form.Check
              className="my-24"
              label="Varaustiedote numero ?"
              id="bookingNoteBySms"
              name="bookingNoteBySms"
              onChange={handleInputChangePhone}
              inline
              checked={editedPhone.bookingNoteBySms}
            />
          </Modal.Body>
          <Modal.Footer>
            <span className="text-danger">Muista tallentaa muutokset !</span>
            <Button
              variant="link"
              onClick={() => setIsPhoneModalVisible(false)}
            >
              Sulje
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={isEMailModalVisible} backdrop="static">
          <Modal.Header>
            <Modal.Title>Muokkaa sähköpostiosoitetta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="emailAddress" className="mb-24">
              <Form.Label>Sähköposti</Form.Label>
              <Form.Control
                name="emailAddress"
                value={editedEmail.emailAddress ?? ''}
                onChange={handleInputChangeEmail}
              />
            </Form.Group>

            <Form.Group controlId="description" className="mb-24">
              <Form.Label>Kuvaus</Form.Label>
              <Form.Control
                name="description"
                value={editedEmail.description ?? ''}
                onChange={handleInputChangeEmail}
              />
            </Form.Group>

            <Form.Check
              className="my-24"
              label="Oletus sähköposti ?"
              id="isPrimary"
              name="isPrimary"
              onChange={handleInputChangeEmail}
              inline
              checked={editedEmail.isPrimary}
            />
            <Form.Check
              className="my-24"
              label="Varaustiedote sähköposti ?"
              id="isBookingNoteEmail"
              name="isBookingNoteEmail"
              onChange={handleInputChangeEmail}
              inline
              checked={editedEmail.isBookingNoteEmail}
            />
          </Modal.Body>
          <Modal.Footer>
            <span className="text-danger">Muista tallentaa muutokset !</span>
            <Button
              variant="link"
              onClick={() => setIsEMailModalVisible(false)}
            >
              Sulje
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
}
export default AddNewCustomer;
